
export type Route = {
    path: string,
    secure: boolean
}

export enum RouteNames {
    Home = "Home",
    Profile = "Profile",
    Projects = "Projects",
    Project = "Project",
    Investment = "Investment",
    Feed = "Feed",
    FeedDetailed = "FeedDetailed",
    Styleguide = "Styleguide",
}

export type RouteMap = { [routeName: string]: Route }


const Routes: RouteMap = {
    [RouteNames.Home]: {
        path: '/',
        secure: true
    },
    [RouteNames.Profile]: {
        path: '/profile',
        secure: true
    },
    [RouteNames.Projects]: {
        path: '/projects',
        secure: true
    },
    [RouteNames.Project]: {
        path: '/projects/:id',
        secure: true
    },
    [RouteNames.Investment]: {
        path: '/investment/:id',
        secure: true
    },
    [RouteNames.Feed]: {
        path: '/feed',
        secure: true
    },
    [RouteNames.Styleguide]: {
        path: '/styleguide',
        secure: false
    },
    [RouteNames.FeedDetailed]: {
        path: '/feed/:id',
        secure: false
    },
}
export default Routes